"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
function sha(bits, message) {
    return __awaiter(this, void 0, void 0, function* () {
        if (typeof window !== 'undefined') {
            const msgBuffer = new window['TextEncoder']('utf-8').encode(message);
            const hashBuffer = yield window['crypto'].subtle.digest(`SHA-${bits}`, msgBuffer);
            const hashArray = Array.from(new Uint8Array(hashBuffer));
            return hashArray.map((b) => (`00${b.toString(16)}`).slice(-2)).join('');
        }
        else {
            return require('crypto').createHash(`sha${bits}`).update(message).digest('hex');
        }
    });
}
exports.sha = sha;
//# sourceMappingURL=sha.js.map